export default {
  apiKey: "AIzaSyBoEDP6-VHd50E70S-XgFk0WbMbDnFzEzQ",
  authDomain: "bancoazteca-lead-genius.firebaseapp.com",
  databaseURL: "https://bancoazteca-lead-genius.firebaseio.com",
  projectId: "bancoazteca-lead-genius",
  storageBucket: "bancoazteca-lead-genius.appspot.com",
  messagingSenderId: "385025906810",
  appId: "1:385025906810:web:8703211b35928adb6c83c3"
};
